<template>
  <div class="menu">
    <transition name="slide">
      <div v-if="isOpen" class="sidemenu-wrapper">
        <SideMenu :isWhite="isWhite" @close="close" />
      </div>
    </transition>
    <div v-if="!isOpen" v-on:click="open">
      <Hamburger :isWhite="isWhite" />
    </div>
  </div>
</template>

<script>
import Hamburger from './Hamburger'
import SideMenu from './SideMenu'

export default {
  name: 'Menu',
  components: {
    Hamburger,
    SideMenu
  },
  props: {
    isWhite: Boolean
  },
  data () {
    return {
      isOpen: false
    }
  },
  methods: {
    open () {
      this.isOpen = true
    },
    close () {
      this.isOpen = false
    }
  }
}
</script>

<style scoped>
.menu {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: flex-end;
}
.slide-enter-active, .slide-leave-active {
  transform: translate(0px, 0px);
  transition: transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}
.slide-enter, .slide-leave-to {
  transform: translateX(100vw) translateX(0px);
}
</style>



// WEBPACK FOOTER //
// src/components/modules/Menu.vue